'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ToolbarButton = require('./ToolbarButton');

var _ToolbarButton2 = _interopRequireDefault(_ToolbarButton);

var _MarkStrategy = require('../strategies/MarkStrategy');

var _MarkStrategy2 = _interopRequireDefault(_MarkStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasMark = function hasMark(value, foundMark) {
  return value.marks.some(function (mark) {
    return mark.type === foundMark;
  });
};

var MarkButton = function MarkButton(_ref) {
  var mark = _ref.mark,
      icon = _ref.icon,
      title = _ref.title,
      value = _ref.value,
      onChange = _ref.onChange;
  return _react2.default.createElement(_ToolbarButton2.default, {
    icon: icon,
    title: title,
    onMouseDown: function onMouseDown(e) {
      return onChange((0, _MarkStrategy2.default)(value, mark));
    },
    active: hasMark(value, mark)
  });
};

MarkButton.propTypes = {
  mark: _propTypes2.default.string.isRequired,
  icon: _propTypes2.default.string.isRequired,
  title: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.object.isRequired,
  onChange: _propTypes2.default.func.isRequired
};

exports.default = MarkButton;